<template>
  <div
    :class="dark ? 'loader dark' : 'loader'"
    :style="{
      width: `${size}px`,
      height: `${size}px`
    }"
  >
    <div
      class="loader-inner"
    />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 30
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.loader {
  @include margin(null auto);
  position: relative;
  display: inline-block;
  border-radius: 50%;
  border: 3px solid rgba($white, .3);

  &-inner {
    width: calc(100% + 6px);
    height: calc(100% + 6px);
    @include position(absolute, -3px null null -3px);
    animation: spin 1s ease-in-out infinite;
    border-radius: 50%;
    border: 3px solid $tertiary;
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-right-color: transparent;
  }

  &.dark {
    border-color: rgba($grey, .5);
    .loader-inner {
      border-top-color: $primary;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
